import { getLanguageCode } from '../user';
import {
    DECIMAL_ODDS_FORMAT,
    AMERICAN_ODDS_FORMAT,
    DEFAULT_LANG,
} from '../constants';
import { BETGENIUS_BETBUILDER_LANG } from '~shared/locales/customLanguageMappings';

export const getBetgeniusOddsFormat = (oddsFormat) => {
     if (oddsFormat === DECIMAL_ODDS_FORMAT) {
        return 'DecimalPrice';
    } else if (oddsFormat === AMERICAN_ODDS_FORMAT ) {
        return 'AmericanPrice';
    }

    return 'FractionalPrice';
};

export const getCultureCode = () => {
    let lang = getLanguageCode();

    if (typeof BETGENIUS_BETBUILDER_LANG[lang] === 'undefined') {
        // Fallback language.
        lang = DEFAULT_LANG;
    }

    return BETGENIUS_BETBUILDER_LANG[lang];
};
